// extracted by mini-css-extract-plugin
export default {"formReset":"ResetPassword_formReset__2XCAl"};